import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { GET_RECEIPT_URL } from "../../operations/queries/operations/queries/get-receipt-url.js";
import { DownloadInvoiceError } from "../../types.js";
const useDownloadInvoice = () => {
  const [downloadInvoiceError, setDownloadInvoiceError] = React.useState();
  const [downloadInvoice, { loading, error }] = useLazyQuery(
    GET_RECEIPT_URL,
    {
      onCompleted: (data) => {
        const responseData = data.getReceiptUrl;
        if ("failures" in responseData && responseData.failures.length && responseData.failures[0]) {
          const failure = responseData.failures[0];
          if (failure.__typename === "GenericFailure") {
            setDownloadInvoiceError(DownloadInvoiceError.GENERIC_ERROR);
          } else if (failure.__typename === "GetReceiptUrlInvalidCustomerInfo") {
            setDownloadInvoiceError(DownloadInvoiceError.INVALID_CUSTOMER_INFO);
          } else if (failure.__typename === "GetReceiptUrlInvalidOrderStatus") {
            setDownloadInvoiceError(DownloadInvoiceError.INVALID_ORDER_STATUS);
          } else {
            setDownloadInvoiceError(DownloadInvoiceError.GENERIC_ERROR);
          }
        }
        if ("receiptUrl" in responseData) {
          window.location.href = responseData.receiptUrl;
          toast.success("checkout.download.invoice.success.label");
        }
      },
      onError: (error2) => {
        console.error(error2);
        setDownloadInvoiceError(DownloadInvoiceError.GENERIC_ERROR);
      },
      fetchPolicy: "no-cache"
    }
  );
  const handleDownloadInvoice = React.useCallback(
    (payload) => {
      setDownloadInvoiceError(void 0);
      downloadInvoice({
        variables: {
          input: {
            customerEmail: payload.emailId,
            orderNumber: payload.orderNumber,
            customerDOB: payload.dateOfBirth
          }
        }
      });
    },
    [downloadInvoice]
  );
  return React.useMemo(
    () => ({
      handleDownloadInvoice,
      downloadInProgress: loading,
      downloadError: downloadInvoiceError,
      error
    }),
    [handleDownloadInvoice, loading, downloadInvoiceError, error]
  );
};
export {
  useDownloadInvoice as default
};
//# sourceMappingURL=use-download-invoice.js.map
